import * as vp from 'vopay';
import * as Yup from 'yup';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { Formik } from 'formik';
import buildLoginForm from './buildLoginForm.helper';
import type { BankAccountLoginHandler } from '../types';
import { useLayout } from '../../../../../../providers/Layout.provider';

const { Box, Button, Term, TextField, ElementContainer } = vp;

type ManualBankAccountFormProps = {
  defaultValues: vp.BankAccountConnectionRequest;
  handlers: BankAccountLoginHandler;
};

type FC = FunctionComponent<ManualBankAccountFormProps>;

const LoginForm: FC = (props: ManualBankAccountFormProps) => {
  const { t } = useTranslation('translations', { keyPrefix: 'OnlineBanking' });
  const { defaultValues, handlers } = props;
  const { color } = useLayout();
  const LoginFormRows = buildLoginForm();
  return (
    <Formik
      initialValues={defaultValues}
      onSubmit={handlers.loginToBankAccount}
      validationSchema={createdValidationSchema()}
    >
      {({ values, touched, errors, handleChange, handleBlur, handleSubmit }) => (
        <form onSubmit={handleSubmit}>
          {LoginFormRows.map(({ id, preset, required, label }) => (
            <ElementContainer
              key={id}
              label={label}
              required={required}
              color="black"
              input={
                <TextField
                  name={id}
                  variant="background"
                  preset={preset}
                  value={formatValues(values[id])}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  error={errors[id] && touched[id] ? errors[id] : null}
                />
              }
            />
          ))}

          <Box pt="md" flx="col" width="100%" height="auto">
            <Term term={`${t('secure')}`} />
          </Box>

          <Box mt="md" height="auto">
            <Button
              id="login"
              label={`${t('continueButton')}`}
              type="submit"
              background={color}
              textColor={vp.getContrastColor(color)}
              width="100%"
              size="xlg"
              round
              bold
              noShadow
              textSize={1}
            />
          </Box>
        </form>
      )}
    </Formik>
  );
  function formatValues(value: string | number | undefined): string | undefined {
    return value?.toString();
  }
  function createdValidationSchema() {
    return Yup.object().shape({
      Username: Yup.string().required(`${t('invalidUsername')}`),
      Password: Yup.string().required(`${t('invalidPassword')}`),
    });
  }
};

export default LoginForm;
